import { Typography } from '@hulu/react-style-components';
import styled from 'styled-components';

import { BlueButton } from '../../../../../components/BlueTheme';

export const StyledReportNotAvailableWrapper = styled.div`
  width: 100%;
  margin: ${({ theme }): string => theme.spacers!.spacer06} auto;
  background-color: ${({ theme }): string => theme.admanColors!.gray.light.bg0[2]};
`;

export const StyledReportNotAvailableContainer = styled.div`
  background-color: ${({ theme }): string => theme.admanColors!.gray.light.bg0[0]};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }): string => theme.spacers!.spacer04};
  padding: ${({ theme }): string => theme.spacers!.spacer06} 0;
`;

export const StyledreportNotAvailableHeading = styled(Typography).attrs({ variant: 'h3Semibold' })<{ $mb: number }>`
  margin-bottom: ${({ theme }): string => theme.spacers!.spacer06};
`;

export const StyledCampaignReportsWrapper = styled.div`
  display: flex;
`;

export const StyledButtonWrapper = styled.div`
  position: relative;
`;

export const Content = styled.div`
  display: none;
  position: absolute;
  padding: ${({ theme }): string => theme.spacers!.spacer04};
  white-space: nowrap;
  border-radius: 8px;
  color: ${({ theme }): string => theme.admanColors!.gray.light.bg0[0]};
  box-shadow: 0 4px 20px -8px ${({ theme }): string => theme.admanColors!.gray.dark.bg0[0]};
  background-color: ${({ theme }): string => theme.admanColors!.gray.dark.bg0[0]};
  font-size: ${({ theme }): string => theme.spacers!.spacer03};

  &::after {
    content: '';
    position: absolute;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 10px solid ${({ theme }): string => theme.admanColors!.gray.dark.bg0[0]};
    top: 22px;
    right: -9px;
    transform: translate(0, -50%) rotate(180deg);
  }
  }
`;

export const ButtonWrapper = styled.span<{ $disabled?: boolean }>`
  display: flex;
  cursor: pointer;

  &:hover {
    fill: ${({ theme }): string => theme.admanColors!.gray.light.fg[1]};
    background-color: ${({ theme, $disabled }): string =>
      $disabled ? 'inherit' : theme.admanColors!.gray.light.bg0[2]};
    border-radius: 25%;
    & + ${Content} {
      display: block;
      transform: translate(-103%, -100%);
    }
  }
`;

export const StyledBlueButton = styled(BlueButton)`
  height: 48px;
`;

export const StyledPageDescription = styled(Typography).attrs({ variant: 'body1' })`
  padding-bottom: ${({ theme }): string => theme.spacers!.spacer05};
`;

export const StyledPageWrapper = styled.div`
  width: 100%;
  display: flex;
  height: calc(100% - 64px);
`;
